import { render, staticRenderFns } from "./icon-picker.vue?vue&type=template&id=3b3c7eee&scoped=true&"
import script from "./icon-picker.vue?vue&type=script&lang=ts&"
export * from "./icon-picker.vue?vue&type=script&lang=ts&"
import style0 from "./icon-picker.vue?vue&type=style&index=0&id=3b3c7eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3c7eee",
  null
  
)

export default component.exports